// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","number":"number-YPyBc","header":"header-1RyeM","filled":"filled-1Fs03","passengerName":"passengerName-2kgC7","payload":"payload-10x0G"};